const routes = [
  {
    path:      '/atencionesporestado',
    name:      'AtencionesPorEstado',
    component: () => import('@/views/dashboards/atenciones/AtencionesPorEstado.vue'),
    meta: { title: 'Por estado',       categoria: 'Atenciones', icono: 'circle-check' }
  },
  {
    path:      '/atencionesporespecialidad',
    name:      'AtencionesPorEspecialidad',
    component: () => import('@/views/dashboards/atenciones/AtencionesPorEspecialidad.vue'),
    meta: { title: 'Por especialidad', categoria: 'Atenciones', icono: 'stethoscope' }
  },
  {
    path:      '/atencionespormedico',
    name:      'AtencionesPorMedico',
    component: () => import('@/views/dashboards/atenciones/AtencionesPorMedico.vue'),
    meta: { title: 'Por médico',       categoria: 'Atenciones', icono: 'person_check' }
  },
  {
    path:      '/atencionespormotivo',
    name:      'AtencionesPorMotivo',
    component: () => import('@/views/dashboards/atenciones/AtencionesPorMotivo.vue'),
    meta: { title: 'Por motivo',       categoria: 'Atenciones', icono: 'message' }
  },
  {
    path:      '/atencionesportipo',
    name:      'AtencionesPorTipo',
    component: () => import('@/views/dashboards/atenciones/AtencionesPorTipo.vue'),
    meta: { title: 'Por tipo',         categoria: 'Atenciones', icono: 'tag' }
  },
  {
    path:      '/atencionespordiag',
    name:      'AtencionesPorDiag',
    component: () => import('@/views/dashboards/atenciones/AtencionesPorDiag.vue'),
    meta: { title: 'Por diagnóstico',  categoria: 'Atenciones', icono: 'medical_information' }
  },
  {
    path:      '/atencionesporhoradia',
    name:      'AtencionesPorHoraDia',
    component: () => import('@/views/dashboards/atenciones/AtencionesPorHoraDia.vue'),
    meta: { title: 'Por hora / día',   categoria: 'Atenciones', icono: 'clock', nuevo: true }
  },
]

export { routes }